
{
  "familyId": "GET-PROC-TOENAME",
  "questions": [
    {
      "id": "GET-PROC-TOENAME-001",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Een fiets kost €400. De prijs stijgt met 15%. Wat is de nieuwe prijs?",
      "options": [
        "€460",
        "€415",
        "€340",
        "€600"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "proc_toename_prijs",
      "variantIndex": 1,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Strategie: bereken de toename en tel op. Stap 1: 15% van €400 = 0,15 × 400 = €60. Stap 2: Nieuwe prijs: €400 + €60 = €460. Of direct: €400 × 1,15 = €460.",
        "distractorExplanations": {
          "0": "Goed! 15% van 400 = 60. Nieuwe prijs: 400 + 60 = €460.",
          "1": "Veelgemaakte fout: 15 optellen in plaats van 15%. 15% van 400 = 60, niet 15.",
          "2": "Veelgemaakte fout: aftrekken in plaats van optellen. Bij een stijging tel je op: 400 + 60 = 460, niet 400 − 60 = 340.",
          "3": "Veelgemaakte fout: 400 × 1,5 = 600. Maar 15% = 0,15, niet 0,5. Factor is 1,15."
        }
      }
    },
    {
      "id": "GET-PROC-TOENAME-002",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Een stad had 80.000 inwoners. Het inwoneraantal groeide met 5%. Hoeveel inwoners zijn er nu?",
      "options": [
        "84.000",
        "80.500",
        "85.000",
        "120.000"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "proc_toename_bevolking",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Strategie: vermenigvuldig met 1,05. Stap 1: 5% van 80.000 = 0,05 × 80.000 = 4.000. Stap 2: 80.000 + 4.000 = 84.000. Of: 80.000 × 1,05 = 84.000.",
        "distractorExplanations": {
          "0": "Goed! 5% van 80.000 = 4.000. Nieuw: 80.000 + 4.000 = 84.000.",
          "1": "Veelgemaakte fout: 500 optellen. 5% van 80.000 = 4.000, niet 500.",
          "2": "Veelgemaakte fout: 5.000 optellen. 5% ≠ 5.000. Bereken: 0,05 × 80.000 = 4.000.",
          "3": "Veelgemaakte fout: 80.000 × 1,5 = 120.000. Maar 5% = 0,05, factor is 1,05."
        }
      }
    },
    {
      "id": "GET-PROC-TOENAME-003",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Met welke factor vermenigvuldig je bij een toename van 25%?",
      "options": [
        "1,25",
        "0,25",
        "1,025",
        "25"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "proc_toename_factor",
      "variantIndex": 3,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Strategie: toename-factor = 1 + percentage als decimaal. Stap 1: 25% = 0,25. Stap 2: Factor = 1 + 0,25 = 1,25.",
        "distractorExplanations": {
          "0": "Goed! Toename van 25% → factor = 1 + 0,25 = 1,25.",
          "1": "Veelgemaakte fout: alleen het percentage als decimaal. 0,25 is de toename, niet de factor. Factor = 1 + 0,25 = 1,25.",
          "2": "Veelgemaakte fout: 2,5% en 25% verwarren. 25% = 0,25, factor = 1,25 (niet 1,025).",
          "3": "Veelgemaakte fout: het percentage zelf als factor. 25 is geen factor. Factor = 1,25."
        }
      }
    },
    {
      "id": "GET-PROC-TOENAME-004",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Een spaarrekening van €2.000 groeit met 3,5% rente. Hoeveel staat er na één jaar?",
      "options": [
        "€2.070",
        "€2.035",
        "€2.700",
        "€2.350"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "proc_toename_rente",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Strategie: vermenigvuldig met 1,035. Stap 1: 3,5% van €2.000 = 0,035 × 2.000 = €70. Stap 2: €2.000 + €70 = €2.070.",
        "distractorExplanations": {
          "0": "Goed! 3,5% van 2.000 = 70. Na één jaar: 2.000 + 70 = €2.070.",
          "1": "Veelgemaakte fout: 35 optellen. 3,5% van 2.000 = 70, niet 35.",
          "2": "Veelgemaakte fout: 35% in plaats van 3,5%. 35% van 2.000 = 700. Maar het is 3,5% = 70.",
          "3": "Veelgemaakte fout: factor 1,35 gebruiken. 3,5% = 0,035, factor = 1,035 (niet 1,35)."
        }
      }
    }
  ]
}
